import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { SettingsProvider } from './components/SettingsContext';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import { UniversalLoggerProvider } from './hooks/useUniversalLogger';
import { routerFutureFlags } from './router/futureFlags';

// Preserve descendant Routes while enabling navigation blockers.
const router = createBrowserRouter([{
  path: '*',
  element: (
    <SettingsProvider>
      <AuthProvider>
        <UniversalLoggerProvider>
          <App />
        </UniversalLoggerProvider>
      </AuthProvider>
    </SettingsProvider>
  ),
}], { future: { v7_relativeSplatPath: true } });
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <RouterProvider router={router} future={{ v7_startTransition: routerFutureFlags.v7_startTransition }} />
  </React.StrictMode>
);
